/*eslint eqeqeq: "off"*/
/*eslint no-unused-vars: "off"*/
/*eslint no-useless-escape: "off"*/


import React, { Component } from 'react'
import { Link } from 'react-router'
import NavBar from './../../ui/template/NavBar'
import SortableTree, { removeNodeAtPath, addNodeUnderParent } from 'react-sortable-tree';
import 'react-sortable-tree/style.css'; // This only needs to be imported once in your app
import firebase, { app } from '../../config/database'
import Config from '../../config/app';
import SectionConfig from '../../config/builder/sections_config';
import { Image } from '../../components/fields'
import Notification from '../../components/Notification';
import SkyLight from 'react-skylight';
import Wizzard from './../../ui/template/Wizzard';
import Input from '../../components/fields/Input'
import T from './../../translations/translate'
import { connect } from 'react-redux';
import HTML from '../../components/fields/HTML_forspeaker';
import update from 'react-addons-update'; // ES6
import Pagination from "./pagination";
import { default as DT } from 'react-datetime'


var _ = require('lodash');
import ReactTable from "react-table"
import "react-table/react-table.css"
import components from '../../config/builder/components'
const ConditionalDisplay = ({ condition, children }) => condition ? children : <div></div>;
const getNodeKey = ({ node }) => node.key;
function MyCell({ value }) {
  return <a href="#" >{value}1</a>
}
class Activity extends Component {
  constructor(props) {
    super(props);

    this.state = {
      treeData: [],
      showAddButton: false,
      pathToDelete: "",
      nodeToDelete: { name: "" },
      inputDelete: "",

      sectionsactive: ["active", ""],
      speakerdate: "",
      speakertitle: "",
      speakerdes: "",
      columns: [],
      tdata: [],
      updatedspeaker: false,
      selectedspeaker: {}
    };

    // this.processDataForShowing = this.processDataForShowing.bind(this);
    this.cancelDelete = this.cancelDelete.bind(this);
    this.doDelete = this.doDelete.bind(this);
    this.appKey = "";

    // this.checkIfCanDeleteApp = this.checkIfCanDeleteApp.bind(this);
  }


  componentDidMount() {

  }

  generateNotifications(item) {
    return (
      <div className="col-md-12">
        <Notification type={item.type} >{item.content}</Notification>
      </div>
    )
  }
  savetoreduxandfirebase() {
    var data = this.processdataforfirebase(this.state.treeData);
    firebase.app.database().ref('myapps/' + this.props.params.sub + "/infobooths").set(data);
    this.props.updateobjectwithtracks({ eventkey: this.props.params.sub, type: 'infobooths', data: data });
  }
  doedit(d) {
    console.log("in edit");
    var key = this.state.selectedspeaker.key;

    console.log(d);
    this.setState({
      tdata: this.state.tdata.map(el => (el.key === key ? { ...el, ...d } : el))
    }, () => {
      console.log(this.state.tdata);
    });
    console.log("Saving to firebase");
    if (d.date == "") {
      delete d.date;
    }
    if (d.des == "") {
      delete d.des;
    }
    console.log(d);
    firebase.app.database().ref("myapps/" + this.props.params.sub + "/af/" + key).update(d);

    firebase.app.database().ref('afeed/' + this.props.params.sub + "/" + key).update(d);
    this.gotomainlist();

  }
  doDelete() {
    console.log("Do delete ");
    console.log(this.state.selectedspeaker);
    var key = this.state.selectedspeaker.key;
    console.log("Update redux state");
    // this.props.updatedataobjectbytype({ eventkey: this.props.params.sub, type: this.props.route.type, key: key, data: undefined })
    console.log("Updating local state");
    this.setState({
      tdata: this.state.tdata.filter(el => (el.key === key ? false : true))
    }, () => {
      console.log(this.state.tdata);
    });
    firebase.app.database().ref('afeed/' + this.props.params.sub + "/" + key).set(null);
    firebase.app.database().ref('myapps/' + this.props.params.sub + "/af/" + key).set(null);

    // this.setState({
    //   treeData: nodes
    // }, () => {
    //   console.log("DOne");
    //   console.log(this.state.treeData);
    //   this.savetoreduxandfirebase();
    // });
    this.refs.deleteDialog.hide()
  }


  cancelDelete() {
    console.log("Cancel Delete");
    this.refs.deleteDialog.hide()
  }

  getSlug() {
    var lastIndex = Config.appEditPath.lastIndexOf("/");
    lastIndex++;
    var slug = Config.appEditPath.substring(lastIndex);
    return slug;
  }


  getObjectDiff(obj1, obj2) {
    const diff = Object.keys(obj1).reduce((result, key) => {
      if (!obj2.hasOwnProperty(key)) {
        result.push(key);
      } else if (_.isEqual(obj1[key], obj2[key])) {
        const resultKeyIndex = result.indexOf(key);
        result.splice(resultKeyIndex, 1);
      }
      return result;
    }, Object.keys(obj2));

    return diff;
  }
  processdataforfirebase(data) {
    var tracks = {};
    var infobooths = {};
    for (let index = 0; index < data.length; index++) {
      tracks[data[index].key] = {
        name: data[index].title,
        o: index
      }
      if (data[index].children) {
        for (let j = 0; j < data[index].children.length; j++) {
          var d = data[index].children[j];
          var infobooth = {};
          infobooth.name = d.title;
          infobooth.o = j;
          infobooth.des = d.des;
          infobooth.track = data[index].key;
          infobooths[d.key] = infobooth;
        }
      }
    }
    return { tracks: tracks, infobooth: infobooths };
  }


  sectionTabContent(treeData) {
    // var data = JSON.parse(JSON.stringify(treeData))
    return (
      <div style={{ padding: '50px' }}>
        <ReactTable
          PaginationComponent={Pagination}
          defaultPageSize={10}
          showPagination={true}
          data={this.state.tdata}
          columns={this.state.columns}
          sortable={true}
          multiSort={true}
          filterable={true}
          defaultSorted={[
            {
              id: "name",
              desc: false
            }
          ]}
          defaultFilterMethod={(filter, row) => { return row[filter.id].toLowerCase().includes(filter.value.toLowerCase()) }}
        />
      </div>

    )
  }





  wizzardsectionchange = () => {
    console.log("Section changed");
    this.setState({
      speakertitle: "",
      speakerdate: "",
      speakerdes: "",
      selectedspeaker: {},
      updatedspeaker: false
    })
  }

  componentWillMount() {
    var columns = [
      {
        Header: 'Title',
        accessor: (row) => {
          if (row.title) {
            return row.title
          } else {
            return ""
          }
        },
        id: "title",
        headerStyle: { whiteSpace: 'unset' },
        style: { whiteSpace: 'unset' },
        maxWidth: 150,
      },
      {
        Header: 'Type',
        accessor: (row) => {
          if (row.type) {
            return row.type
          } else {
            return ""
          }
        },
        id: "type",
        headerStyle: { whiteSpace: 'unset' },
        style: { whiteSpace: 'unset' },
        maxWidth: 150,
      },


      {
        Header: 'Date',
        accessor: (row) => {
          if (row.date) {
            return row.date
          } else {
            return ""
          }
        },
        id: "date",
        headerStyle: { whiteSpace: 'unset' },
        style: { whiteSpace: 'unset' },
        maxWidth: 150,

      },
      {
        Header: 'Description',
        accessor: (row) => {
          if (row.des) {
            return row.des
          } else {
            return ""
          }
        },
        id: "des",
        headerStyle: { whiteSpace: 'unset' },
        style: { whiteSpace: 'unset' },
        Cell: ({ value }) => {
          return <div dangerouslySetInnerHTML={{ __html: value }} />
        },
      },
      {
        Header: 'Action',
        headerStyle: { whiteSpace: 'unset' },
        style: { whiteSpace: 'unset' },
        maxWidth: 100,
        Cell: row => {
          return (
            <div>
              <button className="btn-primary" onClick={() => {
                console.log(row.original);
                console.log("Edit clicked");
                this.setState({
                  updatedspeaker: true,
                  selectedspeaker: row.original,
                  speakertitle: row.original.title ? row.original.title : "",
                  speakerdate: row.original.date ? row.original.date : "",
                  speakerdes: row.original.des ? row.original.des : "",
                  sectionsactive: ["", "active"],
                })
              }
              }> <i className="material-icons">edit</i></button>
              <br /> <br />
              <button className="btn-danger" onClick={() => {
                console.log(row.original);
                console.log("Delte clicked");
                this.refs.deleteDialog.show();
                this.setState({
                  selectedspeaker: row.original
                })
              }
              }> <i className="material-icons">delete</i></button>
            </div>)
        },
      },
    ];
    this.setState({
      columns: columns
    })
    // firebase.app.database().ref("myapps/" + this.props.params.sub + "/af").once("value", snapshot => {

    firebase.app.database().ref("afeed/" + this.props.params.sub).once("value", snapshot => {
      console.log("Got activity data");
      console.log(snapshot.val());
      var activitydata = snapshot.val() ? snapshot.val() : {};
      var tdata = [];
      Object.keys(activitydata).map(key => {
        var d = activitydata[key];
        d['key'] = key
        tdata.push(d);
      })
      this.setState({
        tdata: tdata
      })
    })

  }
  gotomainlist() {
    this.setState({
      sectionsactive: ["active", ""],
      selectedspeaker: {},
      speakertitle: "",
      speakerdate: "",
      speakerdes: ""
    })
  }
  addspeaker() {

    return (
      <div className="center col-md-12 ml-auto mr-auto">

        <div className="input-group">
          <span className="input-group-addon">
            <i className="material-icons">border_color</i>
          </span>
          <div className="form-group label-floating">
            <label className="control-label">{T.td("Title")}</label>
            <input value={this.state.speakertitle} name="name" onChange={(event) => {
              this.setState({
                speakertitle: event.target.value
              })
              // this.saveAppInfo("name", event.target.value);
            }} type="text" className="form-control" />
          </div>
          <span className="input-group-addon">
            <i className="material-icons">date_range</i>
          </span>
          <div className="form-group label-floating">
            <label className="control-label">{T.td("Date(If not selected use current date")}
            </label>
            <DT onChange={(event) => {
              console.log(event.valueOf());
              this.setState({
                speakerdate: event.valueOf()
              })
            }}
              value={this.state.speakerdate}
            />
          </div>
        </div>

        <br />
        <div className="form-group">
          <label>{T.td("Description")}</label>
          <HTML theKey={"htmlkey"} value={this.state.speakerdes} updateAction={(data) => {
            this.setState({
              speakerdes: data
            })
          }}></HTML>

        </div>


        {/*<button type="button" className="btn btn-primary" data-toggle="modal" data-target="#modalCookie1">{T.td("Delete App")}</button>*/}
        <br /> <br />
        <div className="col-md-6 col-md-offset-3">
          <button type="button" className="btn btn-primary"
            onClick={() => {
              console.log(this.state.speakername);
              console.log(this.state.speakerdes);
              console.log("Saving to database and redux");
              console.log(this.state.selectedspeaker);
              var d = {};
              d.date = this.state.speakerdate;
              d.title = this.state.speakertitle;

              d.des = this.state.speakerdes;
              d.type = "notify";
              console.log(d);
              if (this.state.updatedspeaker) {
                console.log("Updating speaker");

                this.doedit(d);
              } else {
                console.log("add speaker");
                var speakercreate = firebase.app.database().ref("afeed/" + this.props.params.sub).push();
                var speakerkey = speakercreate.key;
                // this.props.updatedataobjectbytype({ eventkey: this.props.params.sub, type: this.props.route.type, key: speakerkey, data: d })

                if (d.date == "") {
                  d.date = new Date().getTime();
                }
                if (d.title == "") {
                  delete d.title;
                }
                if (d.des == "") {
                  delete d.des;
                }
                firebase.app.database().ref("myapps/" + this.props.params.sub + "/af/" + speakerkey).set(d);
                speakercreate.set(d)
                d["key"] = speakerkey;
                this.setState({
                  tdata: [...this.state.tdata, d]
                });
                this.gotomainlist();
              }
            }
            }

            disabled={this.state.updatedspeaker ? (((this.state.speakerdate == this.state.selectedspeaker.date) && (this.state.speakertitle == this.state.selectedspeaker.title) && (this.state.speakerdes == this.state.selectedspeaker.des)) || !this.state.speakertitle) : !this.state.speakertitle}>
            {T.td(this.state.updatedspeaker ? "Update " + this.props.route.name : "Add " + this.props.route.name)}
          </button>
        </div>

      </div >)
  }
  capitalize = (s) => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
  }
  render() {
    var theSteps = [
      {
        name: "sections",
        icon: "subject",
        title: T.td(this.capitalize(this.props.route.type)),
        active: this.state.sectionsactive[0],
        label1: T.ts(this.capitalize(this.props.route.type) + " List"),
        content: this.sectionTabContent(this.state.treeData)
      }, {
        name: "images",
        icon: "collections",
        title: T.td("Add " + this.props.route.name),
        active: this.state.sectionsactive[1],
        label1: T.td("Add " + this.props.route.name),
        content: this.addspeaker()
      }
    ];

    return (
      <div>
        <SkyLight hideOnOverlayClicked ref="deleteDialog" title="">
          <span><h3 className="center-block">{T.ts("Delete section")}</h3></span>
          <div className="col-md-12">
            <Notification type="danger" >{T.ts("All data at this location incuding nested sections will be deleted")}!</Notification>
          </div>
          <div className="col-md-12">
            {T.td(this.props.route.name + " name")}
          </div>
          <div className="col-md-12">
            <b>{this.state.selectedspeaker.name}</b>
          </div>

          <div className="col-sm-12" style={{ marginTop: 80 }}>
            <div className="col-sm-6">
            </div>
            <div className="col-sm-3 center-block">
              <a onClick={this.cancelDelete} className="btn btn-info center-block">{T.td("Cancel")}</a>
            </div>
            <div className="col-sm-3 center-block">
              <a onClick={() => this.doDelete()} className="btn btn-danger center-block">{T.td("Delete")}</a>
            </div>

          </div>

        </SkyLight>

        <div className="main-panel col-md-12">
          <NavBar currentLangData={this.props.route.currentLangData}></NavBar>


          <Wizzard
            title={this.capitalize(this.props.route.type)}
            steps={theSteps}
            stepsActivity={this.state.sectionsactive}
            wizzardsectionchange={this.wizzardsectionchange}
          />

        </div>
      </div>)

  }
}

const mapStateToProps = state => ({
  events: state.eventmodel.mainappdata.events
})

const mapDispatchToProps = dispatch => ({
  addnewsection: dispatch.eventmodel.addnewsection,
  updatedataobjectbytype: dispatch.eventmodel.updatedataobjectbytype,
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Activity);


// WEBPACK FOOTER //
// ./src/containers/Builder/activity.js